module.exports = __webpack_public_path__ + "media/images/c01-f57c7185d2934fe4f53adc89bc38c5d8.svg";